var _path, _path2, _path3, _g, _path4, _path5, _g2, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpstage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.329l74.045-42.772 76.805 44.611-74.045 42.771z",
    fill: "#0E0C0C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "upstage_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 16,
    width: 151,
    height: 88
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.805 103.939L0 59.328l74.045-42.772 76.805 44.611-74.045 42.772z",
    fill: "#0E0C0C"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#upstage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.139 109.458L29.434 80.813 76.389 53.35l48.705 28.645-46.955 27.464z",
    fill: "#FF622B"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 -2.758 56.109)",
    fill: "url(#upstage_svg__paint0_linear_3152_1014)",
    d: "M0 0h88.155v49.67H0z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 72.668 12.735)",
    fill: "url(#upstage_svg__paint1_linear_3152_1014)",
    d: "M0 0h93.466v49.67H0z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 88.235L11.96 50.697l62.307-35.991 64.628 37.538-62.306 35.991z",
    fill: "#0E0C0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.59 73.53L11.96 35.99 74.268 0l64.628 37.539-62.306 35.99z",
    fill: "url(#upstage_svg__paint2_linear_3152_1014)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#upstage_svg__clip0_3152_1014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.418 16.384l1.656 1.728 4.648-2.684-1.66-1.725-4.644 2.68zm-2.331 6.043l1.652 1.732 9.892-5.711-1.663-1.726-9.881 5.705zm-1.837 5.758l1.652 1.732 14.634-8.449-1.663-1.726-14.623 8.443zM49.313 40.93l1.65 1.733 31.478-18.174-1.661-1.724L49.31 40.931l.002-.003zm5.922 1.28l1.651 1.73 28.462-16.432-1.662-1.724L55.232 42.21l.004-.002zm27.102 15.225l-1.65-1.731-4.656 2.688 1.668 1.72 4.638-2.677zm2.337-6.047l-1.65-1.73-9.898 5.714 1.67 1.72 9.878-5.704zm1.835-5.759l-1.65-1.73-14.642 8.452 1.669 1.721 14.623-8.443zm13.939-12.745l-1.65-1.73L67.311 49.33l1.669 1.72 31.467-18.167zM94.52 31.61l-1.651-1.731L64.407 46.31l1.669 1.72L94.52 31.61zm-6.185-1.127l-1.65-1.731-26.706 15.418 1.669 1.721 26.689-15.409-.002.001z",
    fill: "url(#upstage_svg__paint3_linear_3152_1014)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 .5 0 1 11.96 35.604)",
    fill: "url(#upstage_svg__paint4_linear_3152_1014)",
    d: "M0 0h75.073v15.175H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.86603 -.5 0 1 76.977 73.063)",
    fill: "url(#upstage_svg__paint5_linear_3152_1014)",
    d: "M0 0h71.498v15.274H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint0_linear_3152_1014",
    x1: 56.6,
    y1: -18.365,
    x2: 49.503,
    y2: 41.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint1_linear_3152_1014",
    x1: 60.009,
    y1: -18.365,
    x2: 15.047,
    y2: 39.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint2_linear_3152_1014",
    x1: 75.428,
    y1: 0,
    x2: 75.428,
    y2: 73.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#322D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#271E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint3_linear_3152_1014",
    x1: 53.375,
    y1: 24.491,
    x2: 74.88,
    y2: 61.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEBCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#805DFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint4_linear_3152_1014",
    x1: 37.537,
    y1: 0,
    x2: 37.537,
    y2: 48.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "upstage_svg__paint5_linear_3152_1014",
    x1: 35.749,
    y1: 0,
    x2: 40.981,
    y2: 126.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#151313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "upstage_svg__clip0_3152_1014"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(.86603 -.5 .86603 .5 32 36.832)",
    d: "M0 0h49.663v49.663H0z"
  })))));
}
export default "data:image/svg+xml;base64,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";
export { SvgUpstage as ReactComponent };